var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-14 f-medium c-pink-deep",domProps:{"innerHTML":_vm._s(_vm.matchResult(_vm.match))}})
}
var staticRenderFns = []

export { render, staticRenderFns }